import { EnvType } from "../services";
import ApiClient from "../api-client";
import ILegacyImporterApiClient from "../LegacyImporter/legacy-importer-api-client";
import LegacyImporterApiClient from "../LegacyImporter/legacy-importer-api-client";
import { StorageKind } from "../Types/storage-kind";
import { ExcelProperties } from "../../../Components/Importer/importer";
import { DownloadFile } from "../../../Utils/helpers";

export default class LegacyImporterService {
  legacyImporterApiClient: ILegacyImporterApiClient;

  constructor(envType: EnvType) {
    this.legacyImporterApiClient = new LegacyImporterApiClient(new ApiClient(envType), envType);
  }

  async Find(kind: StorageKind): Promise<any> {
    return await this.legacyImporterApiClient.Find(kind);
  }

  async GetTokenCounter(): Promise<any> {
    return await this.legacyImporterApiClient.GetTokenCounter();
  }

  async AddTokenCounter(): Promise<any> {
    return await this.legacyImporterApiClient.AddTokenCounter();
  }

  async Load(file: ExcelProperties): Promise<any> {
    return await this.legacyImporterApiClient.Load(file);
  }
  async DeleteExcelFiles(file: ExcelProperties): Promise<any> {
    return await this.legacyImporterApiClient.DeleteExcelFiles(file);
  }

  async Operation(request: any): Promise<any> {
    return await this.legacyImporterApiClient.Operation(request);
  }

  async DownloadExcelFile(file: ExcelProperties): Promise<boolean> {
    try {
      const [fileData, headers] = await this.legacyImporterApiClient.DownloadExcelFile(file);
      DownloadFile(fileData, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", file.fileName);
      return true;
    } catch (error) {
      console.log("Error while downloading file: ", error);
      return false;
    }
  }

  //------Utils------
  GetServiceUrl(): string {
    return this.legacyImporterApiClient.GetApiUrl();
  }
}
